<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t('produto') }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{ $t('promotor') }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{ $t('cadastros') }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{ $t('produto') }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                v-if="permissao.create && !produtoIntegracao"
                                class="delete-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: 'pro-produto-import' })"
                            >
                                {{ $t('importar') }}
                            </button>
                            <button
                                v-if="permissao.create && !produtoIntegracao"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="$router.push({ name: 'pro-produto-new' })"
                            >
                                {{ $t('adicionar') }}
                            </button>
                        </div>
                    </div>

                    <div class="search-and-filter">
                        <div class="search-bar">
                            <search-bar :onSearch="debouncedOnSearch" />
                        </div>
                    </div>

                    <div class="registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            :data="allprodutos"
                            :mobile-cards="false"
                            class="data-table"
                            @sort="sortTable"
                            backend-sorting
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                :key="i"
                                :field="f.key"
                                :label="f.key"
                                :width="f.width"
                                :class="f.key"
                                :sortable="f.sortable"
                                :custom-sort="f.sortFn"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'situacao'">
                                    <ButtonUpdateStatus
                                        :service="service"
                                        :record="'produto'"
                                        :item="props.row"
                                        :identifier="props.row.descricao"
                                        :canDelete="permissao.delete"
                                        @loadData="carregarDados(pagination.currentPage)"
                                    />
                                </div>
                                <div v-else-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: 'pro-produto-edit',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        {{ props.row[f.key] }}
                                    </router-link>
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ProProdutoService from '@/services/promotor/ProProdutoService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import ButtonUpdateStatus from '@/components/shared/buttons/ButtonUpdateStatus.vue';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('pro-produto') && to.name != 'pro-produto-list') {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        ContainerLoader,
        ButtonUpdateStatus,
    },
    data() {
        return {
            rotaAninhada: false,
            produtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PRO_PRODUTO'),
            allprodutos: [],
            service: new ProProdutoService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: null, sortable: false, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 70, sortable: false, sortFn: null },
            ],
            isLoading: false,
            isEmpty: false,
            queryFilter: '',
            sort: {
                order: 'desc',
                column: 'DESCRICAO',
            },
            deleteThis: {},
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'produtos');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'produtos' },
            });
            return;
        } 
        this.rotaAninhada =
            this.$route.name.includes('pro-produto') && this.$route.name != 'pro-produto-list';
        this.carregarDados();
    },
    methods: {
        sortTable(field, order) {
            this.sort.column = field;
            this.sort.order = order;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(currentPage - 1, this.pagination.perPage, this.sort, this.queryFilter)
                .then(this.mapItems)
                .then((value) => {
                    this.allprodutos = value;
                    this.isEmpty = this.allprodutos.length <= 0;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar', e);
                })
                .finally((_) => {
                    this.pagination.resetPagination = false;
                    this.isLoading = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            let produtolist = body.content.map((m) => {
                return {
                    id: m.idproproduto,
                    codigo: m.idproprodutoerp,
                    idproproduto: m.idproproduto,
                    descricao: m.descricao,
                    excluir: 'excluir-produto',
                    situacao: m.situacao,
                };
            });
            return produtolist;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.carregarDados();
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
}
</style>
